import cloneDeep from 'lodash/cloneDeep'

import GetChildCombinedString from 'data/GetChildCombinedString'
import GetChildCombinedURL from 'data/GetChildCombinedURL'

/**
 * Retrieve the child layer data.
 */

export default function getChildData (currentTarget, childLayerConf) {
  // console.debug('getChildData', childLayerConf.titleid, currentTarget, childLayerConf)

  let viewFilterChildProp = ''
  let viewFilterValue = ''

  const layerViewFilterParentProp = childLayerConf?.view?.filter?.parentProp || ''

  if (layerViewFilterParentProp) {
    const properties = currentTarget?.propertiesAll || {}
    const propValue = properties[layerViewFilterParentProp] || ''
    viewFilterValue = propValue
    viewFilterChildProp = childLayerConf?.view?.filter?.childProp || ''
  }

  const viewTitle = childLayerConf?.view?.title || ''
  const viewSortType = childLayerConf?.view?.sort?.type || ''
  const viewSortDirection = childLayerConf?.view?.sort?.direction || ''
  const viewAddWrapper = childLayerConf?.view?.addwrapper !== false
  const viewLimit = childLayerConf?.view?.limit
  const url = GetChildCombinedURL(childLayerConf, currentTarget)

  // Generate fallback URLs with the right params and variable replacements if provided.
  // We do this by creating a cloned version of the layer config with the original URL
  // replaced with the fallback URL.
  const fallbackUrls = []

  // ////////////////////////////////////////////////
  // fallbackUrl (singular, LEGACY)
  // TODO: remove when all occurrances of this have been removed
  //       from client configs
  if (childLayerConf.config?.spatial?.fallbackUrl) {
    const fallbackUrl = childLayerConf.config.spatial.fallbackUrl
    const childLayerFallbackConf = cloneDeep(childLayerConf)
    childLayerFallbackConf.config.spatial.url = fallbackUrl
    const combinedFallbackUrl = GetChildCombinedURL(childLayerFallbackConf, currentTarget)
    fallbackUrls.push(combinedFallbackUrl)
  }
  if (childLayerConf.config?.fallbackUrl) {
    const fallbackUrl = childLayerConf.config.fallbackUrl
    const childLayerFallbackConf = cloneDeep(childLayerConf)
    childLayerFallbackConf.config.spatial.url = fallbackUrl
    const combinedFallbackUrl = GetChildCombinedURL(childLayerFallbackConf, currentTarget)
    fallbackUrls.push(combinedFallbackUrl)
  }

  // ////////////////////////////////////////////////
  // fallbackUrls
  if (childLayerConf.config?.spatial?.fallbackUrls) {
    for (const fallbackUrl of childLayerConf.config.spatial.fallbackUrls) {
      const childLayerFallbackConf = cloneDeep(childLayerConf)
      childLayerFallbackConf.config.spatial.url = fallbackUrl
      const combinedFallbackUrl = GetChildCombinedURL(childLayerFallbackConf, currentTarget)
      fallbackUrls.push(combinedFallbackUrl)
    }
  }

  if (childLayerConf.config?.fallbackUrls) {
    for (const fallbackUrl of childLayerConf.config.fallbackUrls) {
      const childLayerFallbackConf = cloneDeep(childLayerConf)
      childLayerFallbackConf.config.spatial.url = fallbackUrl
      const combinedFallbackUrl = GetChildCombinedURL(childLayerFallbackConf, currentTarget)
      fallbackUrls.push(combinedFallbackUrl)
    }
  }

  // Used by WMSGetFeatureInfoGeoServer in ChildPanelLayerItems.js
  const urlParamsObj = childLayerConf.config?.spatial?.params || childLayerConf.config?.params || {}

  const typelower = (childLayerConf?.type || '').toLowerCase()

  const href = GetChildCombinedString(currentTarget, childLayerConf?.config?.spatial?.href || '')
  const loadertypelower = (childLayerConf?.config?.spatial?.loader || '').toLowerCase()

  let label = childLayerConf.config?.spatial?.label ?? ''
  if (label === '' && (typelower === 'imagewms' || typelower === 'tilewms')) {
    label = childLayerConf.titleAttribute ?? ''
    if (label === '') {
      label = childLayerConf.idAttribute ?? ''
    }
  }

  let id = childLayerConf.config?.spatial?.id ?? ''
  if (id === '' && (typelower === 'imagewms' || typelower === 'tilewms')) {
    id = childLayerConf.idAttribute ?? ''
  }

  const {
    externalLinks = [],
    icon = null,
    InfoPanelCollapse = false,
    localDataSource = false,
    profiles,
    title = null,
    titleid = null,
    type = null
  } = childLayerConf

  const isSelected = childLayerConf.isSelected?.() ?? false

  const childData = {
    icon,
    id,
    InfoPanelCollapse,
    label,
    loadertypelower,
    localDataSource,
    profiles,
    title,
    titleid,
    type,
    typelower,
    url,
    urlParamsObj,
    href,
    viewFilterChildProp,
    viewFilterValue,
    viewAddWrapper,
    viewLimit,
    viewSortDirection,
    viewSortType,
    viewTitle,
    externalLinks,
    isSelected,
    fallbackUrls
  }

  // console.debug('GetChildData - childData', titleid, childData)

  return childData
}
